import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

function parsePermissionsJson(value) {
  if (!value || typeof value !== 'string') return {};
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export async function fetchBoardMemberUsers() {
  const res = await fetch(`${API_BASE}/api/board-member/users`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل المستخدمين'));
  const list = Array.isArray(data) ? data : [];
  return list.map((u) => ({
    id: u.id,
    userName: u.userName,
    fullName: u.fullName ?? '',
    email: u.email ?? '',
    phone: u.phone ?? '',
    isActive: !!u.isActive,
    permissionsJson: u.boardPermissionsJson ?? '{}',
    permissions: parsePermissionsJson(u.boardPermissionsJson),
  }));
}

export async function createBoardMemberUser(payload) {
  const res = await fetch(`${API_BASE}/api/board-member/users`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة المستخدم'));
  return data;
}

export async function updateBoardMemberUser(userId, payload) {
  const res = await fetch(`${API_BASE}/api/board-member/users/${encodeURIComponent(userId)}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحديث المستخدم'));
  return {
    id: data.id,
    userName: data.userName,
    fullName: data.fullName ?? '',
    email: data.email ?? '',
    phone: data.phone ?? '',
    isActive: !!data.isActive,
    permissionsJson: data.boardPermissionsJson ?? '{}',
    permissions: parsePermissionsJson(data.boardPermissionsJson),
  };
}

export async function updateBoardMemberUserPermissions(userId, permissions) {
  const res = await fetch(`${API_BASE}/api/board-member/users/${encodeURIComponent(userId)}/permissions`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify({ boardPermissionsJson: JSON.stringify(permissions ?? {}) }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر حفظ الصلاحيات'));
  return data;
}
